import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { Drawer, Input, Spin } from "antd";

import { Gate } from "../../../store/gates/types";

import styles from "./styles.module.scss";

const { Search } = Input;

export interface GateSelectorProps {
  className?: string;
  value?: number;
  loading?: boolean;
  gates: Gate[];
  onSelect: (value: number) => void;
}

export const GateSelector: React.FC<GateSelectorProps> = (props) => {
  const { t } = useTranslation("gate_selector");
  const { value, loading, gates, onSelect, className } = props;

  const [query, setQuery] = useState("");
  const [isVisible, setVisible] = useState(false);
  const selectedOption = gates.find((gate) => gate.id === value);

  const filterOptions = (gate: Gate): boolean => {
    if (query) {
      const searchPattern = new RegExp(query, "gi");
      return searchPattern.test(gate.label) || parseInt(query, 10) === gate.id;
    }
    return true;
  };

  return (
    <div className={className}>
      <div className={styles.gate} onClick={loading ? () => null : () => setVisible(true)}>
        {loading && <Spin size="small" />}
        {!loading && (selectedOption ? `${selectedOption.label} (${selectedOption.id})` : "No Gate")}
      </div>
      <Drawer
        width="400"
        closeIcon={null}
        className={styles.drawer}
        title={
          <Search
            value={query}
            onInput={(event) => setQuery(event.currentTarget.value)}
            placeholder={t("placeholder")}
          />
        }
        key="right"
        placement="right"
        closable={true}
        visible={isVisible}
        onClose={() => setVisible(false)}
      >
        {gates.filter(filterOptions).map((gate, i) => (
          <div
            key={`option-${i}`}
            className={styles.option}
            onClick={() => {
              onSelect(gate.id);
              setVisible(false);
            }}
          >
            {gate.label} ({gate.id})
          </div>
        ))}
      </Drawer>
    </div>
  );
};
